// extracted by mini-css-extract-plugin
export var aircallIframe = "_kp-3";
export var fabContainer = "_kp-5";
export var fabRinging = "_kp-6";
export var loadingOverlay = "_kp-4";
export var pulse = "_kp-7";
export var widgetContent = "_kp-2";
export var widgetPanel = "_kp-0";
export var widgetPanelExpanded = "_kp-1";